__turbopack_context__.v({
  "button": "Button-module__4hUmeq__button",
});
